import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Forbidden() {
  return (
    <div className="min-h-[80vh] bg-[#FAF9F6] flex items-center justify-center pt-36 sm:pt-44 pb-20 px-4">
      <SEO
        title="403 - Adgang nægtet | ET Danmark ApS"
        description="Du har ikke tilladelse til at tilgå denne ressource."
      />
      <div className="max-w-lg w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-3xl bg-amber-100 text-amber-800 flex items-center justify-center text-3xl mx-auto shadow-sm">
          <i className="fa-solid fa-lock" aria-hidden="true"></i>
        </div>

        <span className="text-xs font-bold uppercase tracking-widest text-amber-800 bg-amber-100/60 px-3 py-1 rounded-full">
          Fejl 403
        </span>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
          Adgang nægtet
        </h1>

        <p className="text-stone-600 text-sm leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side. Du kan navigere tilbage til vores offentlige sider herunder:
        </p>

        <div className="pt-4 flex justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#165B4C] hover:bg-[#11463A] text-white font-bold text-sm shadow transition-colors"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-white border border-stone-300 hover:bg-stone-50 text-stone-800 font-bold text-sm shadow-2xs transition-colors"
          >
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
